// GraphQL query to fetch a product by ID with its first variant
export const getProductByIdQuery = /* GraphQL */ `
  query getProductById($id: ID!, $identifiers: [HasMetafieldsIdentifier!]!) {
    product(id: $id) {
      id
      title
      availableForSale
      metafields(identifiers: $identifiers) {
        id
        key
        namespace
        value
        type
      }
      featuredImage {
        url
        src
        altText
      }
      variants(first: 1) {
        edges {
          node {
            id
            title
            availableForSale
            sellingPlanAllocations(first: 10) {
              edges {
                node {
                  sellingPlan {
                    id
                    name
                  }
                }
              }
            }
            price {
              amount
              currencyCode
            }
            image {
              url
              src
              altText
            }
          }
        }
      }
    }
  }
`;

// GraphQL query to fetch multiple products by their IDs with their first variants
export const getProductsByIdsQuery = /* GraphQL */ `
  query getProductsByIds($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        availableForSale
        variants(first: 1) {
          edges {
            node {
              id
              title
              availableForSale
              price {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`;
